export default __webpack_public_path__ + "static/media/TubeBendingImg.6034deaa.jpg";